import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { RoomEventItem } from "../../Types/RoomEvent"

const initialState: { upcomingEvents: Array<RoomEventItem> } = { upcomingEvents: [] }

const UpcomingEventsSlice = createSlice({
    name: "UpcomingEventsSlice",
    initialState: initialState,
    reducers: {
        setUpcomingEvents(state, action: PayloadAction<Array<RoomEventItem>>) {
           state.upcomingEvents = action.payload
        }
    }
})

export const { setUpcomingEvents } = UpcomingEventsSlice.actions
export default UpcomingEventsSlice.reducer